import { useEffect } from 'react';
import { Extrapolation, interpolate, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';

const LESS_WIDTH = 59;

export const usePickButtonAnimations = (hasMore: boolean, hasLess: boolean) => {
    const moreAnim = useSharedValue(hasMore ? 1 : 0);
    const lessAnim = useSharedValue(hasLess ? 1 : 0);

    useEffect(() => {
        const animationConfig = { duration: 200 };
        moreAnim.value = withTiming(hasMore ? 1 : 0, animationConfig);
        lessAnim.value = withTiming(hasLess ? 1 : 0, animationConfig);
    }, [hasMore, hasLess, moreAnim, lessAnim]);

    const moreButtonStyle = useAnimatedStyle(() => ({
        opacity: moreAnim.value,
    }));

    const lessButtonStyle = useAnimatedStyle(() => ({
        opacity: lessAnim.value,
    }));

    const buttonsContainerStyle = useAnimatedStyle(() => ({
        transform: [
            {
                // translate it with the width of the less button + the space between the buttons
                translateX: interpolate(lessAnim.value, [0, 1], [LESS_WIDTH + 8, 0], Extrapolation.CLAMP),
            },
        ],
    }));

    return {
        moreButtonStyle,
        lessButtonStyle,
        buttonsContainerStyle,
    };
};
